import { useQuery } from "@tanstack/react-query";

import {
  IIntegrationApiKey,
  IIntegrationApiKeyClaim,
} from "../../../@types/admin/AdminIntegrationApiKey";
import { integrationApiKeysService } from "../../../services/admin";
import { ensureOk } from "../../../utils/ensureOk";

export const INTEGRATION_API_KEYS_QUERY_KEY = "admin-integration-api-keys";
export const INTEGRATION_API_KEY_CLAIMS_QUERY_KEY =
  "admin-integration-api-key-claims";

/**
 * Every integration API key (metadata only — the key values are not
 * retrievable). Re-read on each visit: the global QueryClient disables
 * refetch-on-mount and the page has no Refresh button.
 */
export function useIntegrationApiKeys() {
  const { data, isLoading, isError, error } = useQuery<IIntegrationApiKey[]>({
    queryKey: [INTEGRATION_API_KEYS_QUERY_KEY],
    queryFn: async () => ensureOk(await integrationApiKeysService.getApiKeys()),
    refetchOnMount: "always",
  });

  return { apiKeys: data ?? [], isLoading, isError, error };
}

/** The claims a key can be granted, for the create/edit checklist. */
export function useIntegrationApiKeyClaims() {
  const { data, isLoading, isError } = useQuery<IIntegrationApiKeyClaim[]>({
    queryKey: [INTEGRATION_API_KEY_CLAIMS_QUERY_KEY],
    queryFn: async () => ensureOk(await integrationApiKeysService.getClaims()),
  });

  return { claims: data ?? [], isLoading, isError };
}
